import iconsPng from '@/assets/img/png/icons';
import { Button, HStack, Image, Text, VStack } from '@chakra-ui/react';
import UserProfileBox, { USER_PROFILE_CARD_HEIGHT } from './UserProfileBox';
import UserProfileBoxInfoPiece from './UserProfileBoxInfoPiece';

interface UserContactDetailsBoxProps {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  location: string;
  onClickEdit: () => void;
  hideEditButton?: boolean;
}

const UserContactDetailsBox = ({
  email,
  firstName,
  lastName,
  phone,
  location,
  onClickEdit,
  hideEditButton = false,
}: UserContactDetailsBoxProps) => {
  return (
    <UserProfileBox style={{ height: USER_PROFILE_CARD_HEIGHT }}>
      <HStack justifyContent={'space-between'}>
        <Text variant={'urbanistSemiBoldTitle'} marginBottom={'10px'}>
          Contact Details
        </Text>
        {!hideEditButton && (
          <Button
            variant="link"
            color="primary.500"
            _hover={{ opacity: 0.7, textDecoration: 'none' }}
            onClick={onClickEdit}
            fontSize="16px"
            leftIcon={
              <Image
                alt="edit-icon"
                src={iconsPng.penPurple}
                width={'12px'}
                height={'12px'}
                objectFit="cover"
                style={{ marginRight: '4px', marginBottom: '1px' }}
              />
            }
          >
            Edit
          </Button>
        )}
      </HStack>
      <VStack alignItems={'start'} gap={'20px'} marginTop={'20px'}>
        <UserProfileBoxInfoPiece title={'EMAIL ADDRESS'} text={email} />
        <UserProfileBoxInfoPiece title={'NAME'} text={`${firstName} ${lastName}`} />
        <UserProfileBoxInfoPiece title={'PHONE NUMBER'} text={phone} />
        {location !== '/' && <UserProfileBoxInfoPiece title={'LOCATION'} text={location} />}
      </VStack>
    </UserProfileBox>
  );
};

export default UserContactDetailsBox;
